import { Component } from '@angular/core';

@Component({
  selector: 'app-how-to-buy',
  templateUrl: './how-to-buy.component.html',
  styleUrls: ['./how-to-buy.component.scss']
})
export class HowToBuyComponent {
  items= [
    {
      head: 'buy_head_1',
      para: 'buy_para_1'
    },
    {
      head: 'buy_head_2',
      para: 'buy_para_2'
    },
    {
      head: 'buy_head_3',
      para: 'buy_para_3'
    }
  ]
}
